import {useMemo} from 'react';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';
import {LAYOUT_MODE_KEY} from 'utils/constants';

export type LayoutMode = 'default' | 'kiosko';

export const useLayoutMode = (): LayoutMode => {
  const isKioskoConnected = useKioskoStore(state => state.connection.isConnected);

  return useMemo(() => {
    const storedLayout = localStorage.getItem(LAYOUT_MODE_KEY);
    if (storedLayout === 'kiosko') {
      return 'kiosko';
    }

    return isKioskoConnected ? 'kiosko' : 'default';
  }, [isKioskoConnected]);
};
